import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-float">
      <div className="glass rounded-2xl p-6 max-w-4xl mx-auto shadow-2xl border border-quantum-500/20">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-gradient-to-br from-quantum-400 to-quantum-600 rounded-full flex items-center justify-center">
              <FaCookie className="w-6 h-6 text-dark-900" />
            </div>
          </div>
          
          <div className="flex-grow">
            <h3 className="text-white font-semibold mb-2">We use cookies</h3>
            <p className="text-gray-400 text-sm mb-2">
              We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
              By clicking "Accept All", you consent to our use of cookies. 
              <Link to="/cookies" className="text-quantum-400 hover:underline ml-1">
                Learn more
              </Link>
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 flex-shrink-0">
            <button
              onClick={handleReject}
              className="px-4 py-2 bg-dark-700 text-gray-300 rounded-lg hover:bg-dark-600 transition-colors text-sm font-medium whitespace-nowrap"
            >
              Reject
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-gradient-to-r from-quantum-500 to-quantum-600 text-white rounded-lg hover:from-quantum-600 hover:to-quantum-700 transition-all transform hover:scale-105 text-sm font-medium whitespace-nowrap"
            >
              Accept All
            </button>
          </div>

          <button
            onClick={handleReject}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            aria-label="Close"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;

